module.exports = {"Type":"Text","Output":true,"Fields":[{"label":"Message","type":"multiline","name":"text","serializeTo":"q"},{"label":"Name of the variable","name":"name","serializeTo":"node"},{"label":"Publisher visibility","type":"yesno","name":"publisher","defaultValue":"No"},{"label":"Bypass current node if variable has value?","type":"yesno","name":"bypass","advanced":true},{"label":"Speak","type":"multiline","name":"speak"}],"Header":{"Color":"black","BackgroundColor":"#e0e0e0","Text":null}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/Text.json
// module id = 676
// module chunks = 0